import type { TransactionSpendingLimitResponseOptions } from "deso-protocol";
import { identity } from "deso-protocol";

export async function guardTxPermission(
  spendingLimitOptions: TransactionSpendingLimitResponseOptions,
) {
  const hasPermissions = identity.hasPermissions(spendingLimitOptions);
  const guard = (hasPermissions: boolean) => {
    if (!hasPermissions) {
      return identity.requestPermissions({
        ...spendingLimitOptions,
        GlobalDESOLimit:
          (identity.transactionSpendingLimitOptions.GlobalDESOLimit ?? 0) +
          (spendingLimitOptions.GlobalDESOLimit ?? 0),
      });
    }
  };
  if (typeof hasPermissions === "boolean") {
    return guard(hasPermissions);
  } else {
    return hasPermissions.then(guard);
  }
}
